import { expValWithoutExposure } from '@townsquare/stat-sig';
import { TOWNSQUARE_REMOVE_DISCOVER_FROM_FYP_EXPERIMENT } from '@townsquare/stat-sig/experiments';
import { fg } from '@townsquare/stat-sig/gate';

export const disableDiscoverOnFyp = (routeName: string): boolean =>
	routeName === 'hometab' &&
	expValWithoutExposure(TOWNSQUARE_REMOVE_DISCOVER_FROM_FYP_EXPERIMENT, 'cohort', 'control') === 'variation';

export const isLabelledFeedResourceEnabled = (routeName: string, hasRovoWorkspace: boolean): boolean => {
	const isPopularTabsEnabled = fg('townsquare_enable_popular_tabs');
	return hasRovoWorkspace && isPopularTabsEnabled && !disableDiscoverOnFyp(routeName);
};
